import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// CSS

import "./css/Buttons.scss";

const Buttons = ({ text, color, link, style, onClick }) => {
  const buttonVariants = {
    initial: {},
    animate: {},
  };
  if (link !== undefined) {
    return (
      <Link to={`/${link}`} className={`button ${color}`} style={style}>
        {text}
      </Link>
    );
  } else {
    if (onClick) {
      return (
        <motion.button
          className={`button ${color}`}
          style={style}
          onClick={onClick}
          variants={buttonVariants}
          whileHover='animate'
        >
          {text}
        </motion.button>
      );
    } else {
      return (
        <motion.button className={`button ${color}`} style={style}>
          {text}
        </motion.button>
      );
    }
  }
};

export default Buttons;
